import { Box, Link, Stack, Typography } from '@mui/material'
import TicketData, { TicketDataRow } from 'components/TicketData/TicketData'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { checkCode } from 'service/PreregisService'
import QRCode from 'react-qr-code'

const Thankyou: React.FC<{}> = ({}) => {
  const [ticketData, setTicketData] = useState<TicketDataRow[]>([])
  const [isShowQrCode, setIsShowQrCode] = useState<boolean>(true)
  const { qrCode } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    const check = async (code: string) => {
      const response = await checkCode(code)
      const rawData = response?.data.data
      if (response?.data?.statusCode !== 91) {
        navigate('/')
        return
      }

      setTicketData([
        {
          tittle: 'Ticket Type:',
          value: rawData?.ATTENDEE_TYPE,
        },
        {
          tittle: 'Entrant Code:',
          value: rawData?.VALIDATE_ACCOUNT_ID,
        },
        {
          tittle: 'Full Name:',
          value: rawData?.FIRST_NAME + ' ' + rawData?.LAST_NAME,
        },
        {
          tittle: 'E-mail:',
          value: rawData?.EMAIL,
        },
      ])
    }
    if (!!!qrCode) {
      navigate('/')
      return
    }
    check(qrCode)
  }, [])

  return (
    <Stack spacing={3}>
      <Typography variant="h5" sx={{ textAlign: 'left', fontWeight: 400, fontSize: '20px' }}>
        <span style={{ fontSize: '24px', fontWeight: 'bold' }}>3-Day Live In-Person Event</span>{' '}
        <br /> Date: 12 - 14 Apr 2024 <br /> Time: 10AM <br /> Venue: Singapore EXPO
      </Typography>
      <div className="flex flex-col items-center pb-4">
        <Typography sx={{ fontSize: '16px', mb: 1 }}>Your QR Code</Typography>
        <QRCode
          size={256}
          className="w-[150px] h-[150px]"
          value={String(qrCode)}
          viewBox={`0 0 256 256`}
        />
      </div>
      <TicketData rows={ticketData} />
      <Box sx={{ mt: 2 }}>
        <Typography component="em" variant="body2" sx={{ mt: 1 }}>
          Please save and present the e-ticket for registration on the day of the event. A copy of
          this ticket has also been sent to your email address
        </Typography>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Typography variant="subtitle2">Instructions:</Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          1. Registration counters will open from 8.30 am on the day of the Event and you are
          advised to arrive early for registration.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          2. The event is free seating, and entry to the event hall is staggered based on ticket
          type:
          <ul style={{ listStyle: 'inside' }}>
            <li>GENERAL ADMISSION: Doors open 30 minutes before 10 AM</li>
            <li>VIP ADMISSION: Doors open 40 minutes before 10 AM.</li>
            <li>⁠ELITE ADMISSION: Doors open 50 minutes before 10 AM.</li>
          </ul>
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          3. Please present the above QR code at the registration counter during the event day to
          exchange for your Event Wristband, or you will be denied entry in all cases.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          4. Each QR code is interchangeable for one event wristband, and each event wristband is
          redeemable once and for one person only.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          5. The Event Wristband must be worn throughout the event day(s). Lost or stolen event
          wristbands can be replaced for a fee.
        </Typography>
      </Box>

      <Box sx={{ mt: 2 }}>
        <Typography variant="subtitle2">EVENTS TERMS & CONDITIONS</Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          1. Your Event Wristband will be required for admission into "Joey Yap's QiMen Academy
          2024".
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          2. Each Event Wristband admits one (1) person only. No sharing of seats allowed.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          3. The organizer reserves the right to refuse admission if the name on the issued ticket
          does not match with the Participant’s photo ID.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          4. Strictly no cancellations, refunds, or transfers allowed once ticket(s) have been
          purchased and/or issued.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          5. In the event of any dispute arising from or relating to your purchase of the ticket(s),
          the organizer's maximum liability to you shall not exceed the total amount you have paid
          for your ticket(s).
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          6. This ticket is not for resale and is non-exchangeable for any form of cash or credit
          alternative.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          7. Audio and/or video recordings of the Event are strictly prohibited to respect copyright
          and intellectual property laws. Offenders will be required to delete any recordings and
          may be asked to leave the event. Please respect the copyright and intellectual property
          laws.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          8. To minimize any disruptions to the Event, all ticket holders are required to have
          registered and be seated inside the venue by 10:00 am. The organizer reserves the right to
          refuse admission to those who fail to comply with this condition.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          9. Participants must be at least 15 years of age. Children below the age of 15 are not
          admissible.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          10. Dress code is Smart Casual.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          11. The organizer reserves the right, without refund of any amount paid, to refuse
          admission, or eject any person whose behavior does not comply with the rules and
          regulations set forth by the organizer and/or deemed to be disorderly.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          12. The organizer reserves the right to substitute the speaker, price, venue and/or the
          date of the event and/or relocate your seat to a different zone at its discretion.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          13. Neither the organizer nor the venue management will be responsible for any loss, theft
          or damage of your personal belongings.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          14. Your use of this ticket constitutes your acceptance of the organizer’s full Terms &
          Conditions as stipulated on{' '}
          <a href="https://fsa.joeyyap.com/seminartermsandconditions" style={{ color: 'blue' }}>
            www.joeyyap.com/seminartermsandconditions.
          </a>{' '}
          These Terms & Conditions are subject to change and updated from time to time, with or
          without prior notice.
        </Typography>
      </Box>
    </Stack>
  )
}

export default Thankyou
